<span
  *ngIf="statusConfig?.[status]"
  class="inline-flex items-center text-white font-bold text-[10px] rounded-full px-4 py-2"
  [ngClass]="statusConfig[status].bgClass">
  <i [class]="statusConfig[status].iconClass"></i>
  <span class="ml-2 hidden md:block">{{ translatedText }}</span>
</span>
